"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "@opensea/next-themes";
import { AbstractLogo, ApeLogo, BeraChainLogo, EtherscanLogo, GunzillaLogo, HyperEVMLogo, RoninLogo, SolanaLogo, SomniaLogo, UnichainLogo } from "@opensea/ui-kit/icons";
import { useChains } from "./use-chains";
const CHAIN_IDENTIFIER_TO_EXPLORER = {
  ethereum: EtherscanLogo,
  base: EtherscanLogo,
  arbitrum: EtherscanLogo,
  avalanche: EtherscanLogo,
  polygon: EtherscanLogo,
  zora: EtherscanLogo,
  optimism: EtherscanLogo,
  solana: SolanaLogo,
  bera_chain: BeraChainLogo,
  unichain: UnichainLogo,
  ape_chain: ApeLogo,
  ronin: RoninLogo,
  gunzilla: GunzillaLogo,
  abstract: AbstractLogo,
  hyperevm: HyperEVMLogo,
  somnia: SomniaLogo
};
export function useBlockExplorer(identifier) {
  const $ = _c(20);
  const {
    chains
  } = useChains();
  const {
    resolvedTheme
  } = useTheme();
  let t0;
  if ($[0] !== chains || $[1] !== identifier) {
    let t1;
    if ($[3] !== identifier) {
      t1 = v => v.identifier === identifier;
      $[3] = identifier;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = chains.find(t1);
    $[0] = chains;
    $[1] = identifier;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const chain = t0;
  let t1;
  if ($[5] !== chain?.blockExplorer) {
    t1 = address => chain?.blockExplorer.addressUrlTemplate.replace(":address", address) ?? "";
    $[5] = chain?.blockExplorer;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const getAddressUrl = t1;
  let t2;
  if ($[7] !== chain?.blockExplorer) {
    t2 = hash => chain?.blockExplorer.transactionUrlTemplate.replace(":hash", hash) ?? "";
    $[7] = chain?.blockExplorer;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const getTransactionUrl = t2;
  let t3;
  if ($[9] !== chain?.blockExplorer) {
    t3 = () => chain?.blockExplorer.name ?? "";
    $[9] = chain?.blockExplorer;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const getName = t3;
  let t4;
  if ($[11] !== chains || $[12] !== identifier || $[13] !== resolvedTheme) {
    t4 = () => {
      const predefinedChainIdentifier = identifier;
      if (identifier && CHAIN_IDENTIFIER_TO_EXPLORER[predefinedChainIdentifier]) {
        return {
          icon: CHAIN_IDENTIFIER_TO_EXPLORER[predefinedChainIdentifier]
        };
      }
      const blockExplorer = chains.find(c => c.identifier === identifier)?.blockExplorer;
      if (blockExplorer?.logoLightMode && blockExplorer.logoDarkMode) {
        return {
          src: resolvedTheme === "dark" ? blockExplorer.logoDarkMode.mono : blockExplorer.logoLightMode.mono
        };
      }
      return {
        src: ""
      };
    };
    $[11] = chains;
    $[12] = identifier;
    $[13] = resolvedTheme;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const getLogo = t4;
  let t5;
  if ($[15] !== getAddressUrl || $[16] !== getLogo || $[17] !== getName || $[18] !== getTransactionUrl) {
    t5 = {
      getAddressUrl,
      getTransactionUrl,
      getName,
      getLogo
    };
    $[15] = getAddressUrl;
    $[16] = getLogo;
    $[17] = getName;
    $[18] = getTransactionUrl;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}